<template>
  <b-button v-if="items" variant="success" @click="onExport">
    <i class="fa fa-download"></i> Excel
  </b-button>
</template>

<script>
import XLSX from "xlsx";
export default {
  name: "ExcelButton",
  props: {
    items: null,
    filename: {
      type: String,
      default: "export.xlsx"
    }
  },
  methods: {
    onExport() {
      if (this.items) {
        const dataWS = XLSX.utils.json_to_sheet(this.items);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(wb, this.filename);
      }
    }
  }
};
</script>